/* unplugin-vue-components disabled */// extracted by css-extract-rspack-plugin
export default {"agreementContainer":"agreement_agreementContainer__AJavX"};